import React, { useState, useEffect } from 'react';
import openSocket from 'socket.io-client';
import { Redirect } from 'react-router';
import BuyStakesHeader from '../components/layout/header/BuyStakesHeader';
import BettingCard from '../components/card/buyStakesCard/BettingCard';
import Footer from '../components/layout/Footer';
import { IsAuth } from '../utils/Auth';
import { items } from '../data';
import axios from 'axios';
const BuyStakes = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const allEvents = async () => {
      try {
        const response = await axios.get('/api/v1/events');
        console.log(response);
        console.log(response.data);
        console.log(response.data.data);
        setEvents(response.data.data);
      } catch (err) {
        console.log(err.response.data.error);
      }
    };

    allEvents();
    // openSocket('http://localhost:5000');
  }, []);

  return (
    <div>
      <BuyStakesHeader />
      <div className='pb-5 mb-5'>
        {events.map((item) => (
          // <div key={item._id}>{item.game}</div>
          <BettingCard key={item._id} item={item} />
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default BuyStakes;
